import { noop } from '~/utils/object';

export type StorageReturn = string | null;

export type StorageType = {
  getItem: (key: string) => StorageReturn;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
};

const localStoragePolyfill = {
  getItem: () => null,
  setItem: noop,
  removeItem: noop,
};

// we use localStorage so that we can store data and access it after
// the user is redirected to a SAML provider and comes back, reloading the app
const Storage: StorageType = (() => {
  try {
    return window.localStorage || localStoragePolyfill;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return localStoragePolyfill;
  }
})();

export default Storage;
